module.exports = __webpack_public_path__ + "img/lcl-top-profile.7e6b3ff8.svg";